module.exports = __webpack_public_path__ + "static/media/at-the-heart-of-the-consumer-s-news-strategies-for-coping-with-inflation.c3ceeeb7.png";